"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=orientation.js.map